import PlusIcon from '../../assets/plusicon.svg'
import Avatars from '../../assets/avatarcircles.svg'
import Animation from '../../assets/animation_main.svg'
import SuccessAnimation from '../../assets/success.json'
import { useState } from 'react'
import Lottie from 'lottie-react'
import WaitlistForm from './wait-form'

const WaitList = () => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  return (
    <div className='flex flex-col items-center justify-start min-h-screen md:[@media(min-height:790px)]:h-screen md:[@media(min-height:790px)]:overflow-hidden px-10 md:px-20 py-10 md:[@media(min-height:790px)]:py-6'>
      <div className='flex flex-col gap-2 md:flex-row items-center justify-between w-full mb-8 md:[@media(min-height:790px)]:mb-4 xl:mb-6'>
        <div className='text-black text-[24px] font-[800]'>
          <span className='text-gray-900'>IRIS</span>
        </div>
        <div className='border border-[#FF6600] rounded-[48px] p-2 gap-2 hidden md:flex flex-row items-center justify-center'>
          <img src={PlusIcon} alt='Plus icon' />
          <div>Assessment Tool</div>
        </div>
      </div>

      <div className='flex flex-row items-center justify-between w-full gap-10 md:[@media(min-height:790px)]:flex-1 md:[@media(min-height:790px)]:overflow-hidden'>
        <div className='flex flex-col items-start justify-start md:[@media(min-height:790px)]:justify-center w-full h-full'>
          <div className='mb-4 md:[@media(min-height:790px)]:mb-6 flex flex-col items-start'>
            <div className='text-[80px] sm:text-[128px] md:text-[96px] lg:text-[108px] xl:text-[128px] font-light text-black text-start leading-none'>
              Join Our
            </div>
            <div className='flex items-baseline gap-2'>
              <div className='text-black font-[600] text-[80px] sm:text-[128px] md:text-[96px] lg:text-[108px] xl:text-[128px] leading-none'>
                <span className='text-[#FF6600] text-start'>W</span>aitlist
              </div>
              {/* Avatar Group */}
              <img
                src={Avatars}
                className='xl:flex hidden'
                alt='User avatars'
              />
            </div>
          </div>

          {/* Description */}
          <p className='text-gray-700 text-sm leading-relaxed text-start mb-6 md:[@media(min-height:790px)]:mb-8'>
            IRIS helps partners, especially intending
            couples, identify early warning signs of intimate partner violence
            before harm occurs. It&apos;s not designed to break relationships,
            but to strengthen them by encouraging healthier and safer means of
            dealing with situations. Join the waitlist to get early access,
            updates, and help shape new features.
          </p>

          {/* Form or Success Message */}
          {!isSubmitted ? (
            <WaitlistForm onSubmit={() => setIsSubmitted(true)} />
          ) : (
            <div className='flex flex-col items-center w-full gap-4'>
              <Lottie
                animationData={SuccessAnimation}
                loop={false}
                style={{ width: 200, height: 200 }}
              />
              <p className='text-gray-600 text-sm'>
                You have successfully joined our waitlist
              </p>
            </div>
          )}
        </div>

        <div className='h-full w-full hidden flex-col items-center justify-center relative xl:flex'>
          <img
            src={Animation}
            className='max-h-full object-contain'
            alt='Assessment tool animation'
          />
        </div>
      </div>
    </div>
  )
}

export default WaitList
